var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.dialogVisible,
        "custom-class": "c-dialog",
        "close-on-click-modal": false,
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.handleClose,
      },
    },
    [
      _c("div", { staticClass: "desc" }, [
        _vm._v("您有"),
        _c("span", { staticClass: "num" }, [_vm._v(" 1 ")]),
        _vm._v("条新的报修待处理"),
      ]),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-form",
            { attrs: { "label-width": "100px" } },
            [
              _c(
                "el-col",
                { attrs: { sm: 12, md: 8, lg: 6 } },
                [
                  _c("el-form-item", { attrs: { label: "资产编号" } }, [
                    _c(
                      "div",
                      {
                        staticClass: "hidden-text",
                        attrs: { title: _vm.instru.assetsNo },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.instru.assetsNo) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { sm: 12, md: 8, lg: 6 } },
                [
                  _c("el-form-item", { attrs: { label: "仪器名称" } }, [
                    _c(
                      "div",
                      {
                        staticClass: "hidden-text",
                        attrs: { title: _vm.instru.instruName },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.instru.instruName) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { sm: 12, md: 8, lg: 6 } },
                [
                  _c("el-form-item", { attrs: { label: "品牌/型号" } }, [
                    _c(
                      "div",
                      {
                        staticClass: "hidden-text",
                        attrs: { title: _vm.instru.brandName },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.instru.brandName) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { sm: 12, md: 8, lg: 6 } },
                [
                  _c("el-form-item", { attrs: { label: "仪器原值" } }, [
                    _c("div", { staticClass: "hidden-text" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s((_vm.instru.instruCost / 100).toFixed(2)) +
                          "\n          "
                      ),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { sm: 12, md: 8, lg: 6 } },
                [
                  _c("el-form-item", { attrs: { label: "使用人" } }, [
                    _c(
                      "div",
                      {
                        staticClass: "hidden-text",
                        attrs: { title: _vm.instru.usePeople },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.instru.usePeople) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { sm: 12, md: 8, lg: 6 } },
                [
                  _c("el-form-item", { attrs: { label: "仪器归属部门" } }, [
                    _c(
                      "div",
                      {
                        staticClass: "hidden-text",
                        attrs: { title: _vm.instru.useDept },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.instru.useDept) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { sm: 12, md: 8, lg: 6 } },
                [
                  _c("el-form-item", { attrs: { label: "仪器规格" } }, [
                    _c(
                      "div",
                      {
                        staticClass: "hidden-text",
                        attrs: { title: _vm.instru.gg },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.instru.gg) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { sm: 12, md: 8, lg: 6 } },
                [
                  _c("el-form-item", { attrs: { label: "是否进口" } }, [
                    _c("div", { staticClass: "hidden-text" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.instru.source == "1" ? "是" : "否") +
                          "\n          "
                      ),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { sm: 12, md: 8, lg: 6 } },
                [
                  _c("el-form-item", { attrs: { label: "资产管理员" } }, [
                    _c(
                      "div",
                      {
                        staticClass: "hidden-text",
                        attrs: { title: _vm.instru.assetPeople },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.instru.assetPeople) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { sm: 12, md: 8, lg: 6 } },
                [
                  _c("el-form-item", { attrs: { label: "故障描述" } }, [
                    _c(
                      "div",
                      {
                        staticClass: "hidden-text",
                        attrs: { title: _vm.instru.faultDes },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.instru.faultDes) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleDealWith } },
            [_vm._v("去处理")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }